import { useEffect, useState, useContext } from 'react'
import { Box, TextField, Typography } from '@material-ui/core'
import QuestionDescription from '../SharedComponent/QuestionDescription'
import { ValidatorContext, QuestionItemContext } from 'containers/Examination/ExaminationContext'

const ShortAnswer = ({onChange}) => {
  const validator = useContext(ValidatorContext)
  const questionItem = useContext(QuestionItemContext)
  const [description, setDescription] = useState('')
  const [images, setImages] = useState(null)
  const [answer, setAnswer] = useState('')
  const [pts, setPts] = useState(1)
  const [answerHelperText, setAnswerHelperText] = useState('')
  const [answerHasError, setAnswerHasError] = useState(false)

  const updateDescription = (description, images) => {
    setImages(images)
    setDescription(description)
  }

  const handleAnswerInput = (e) => {
    setAnswer(e.target.value)
  }

  const handlePtsInput = (e) => {
    setPts(e.target.value)
  }

  useEffect(() => {
    onChange({
      type: "SHORT_ANSWER",
      description,
      images,
      answerKey: answer,
      option: null,
      pts
    })
  }, [description, answer, pts, images])

  useEffect(() => {
    setAnswerHelperText('')
    setAnswerHasError(false)
    if (validator.validationError.answer !== undefined) {
      setAnswerHelperText(validator.validationError.answer)
      setAnswerHasError(true)
    }
  }, [validator])

  useEffect(() => {
    if (questionItem !== undefined && questionItem !== null) {
      setAnswer(questionItem.answer)
      setImages(questionItem.images)
      setPts(questionItem.pts)
    }
  }, [questionItem])

  return (
    <Box display="flex" flexDirection="column">
      <Box>
        <Typography variant="h6">Short Answer</Typography>
      </Box>
      <Box>
        <QuestionDescription onChange={updateDescription} />
      </Box>
      <Box marginTop={3}>
        <TextField
          id="answer"
          label="Describe the correct answer here"
          multiline
          fullWidth
          onChange={handleAnswerInput}
          helperText={answerHelperText}
          error={answerHasError}
          value={answer}
        />
      </Box>
      <Box>
        <TextField
          type="number"
          label="Pts"
          fullWidth
          defaultValue={pts}
          value={pts}
          onChange={handlePtsInput}
        />
      </Box>
    </Box>
  )
}

export default ShortAnswer